export class InvestigationTypeDeletionImpactEntity {
  public activeInvestigationsCount!: number;
  public linkedInvestigations!: LinkedInvestigationEntity[];
  public linkedInvestigationForms!: LinkedInvestigationFormEntity[];
  public linkedEmailTemplates!: LinkedEmailTemplateEntity[];
  public linkedProcessChecklists!: LinkedProcessChecklistEntity[];
  public hasDependencies!: boolean;
}

export class LinkedInvestigationEntity {
  public id!: string;
  public name!: string;
}

export class LinkedInvestigationFormEntity {
  public id!: string;
  public name!: string;
}

export class LinkedEmailTemplateEntity {
  public id!: string;
  public name!: string;
}

export class LinkedProcessChecklistEntity {
  public id!: string;
  public name!: string;
}
